import React from "react";
import PropTypes from "prop-types";
import Button from "../../inputs/button";
import xGreenIcon from "../../../assets/svgs/x-green.svg";
import "./ContextualSwitchModal.scss";

/**
 * ContextualSwitchModal - Confirmation modal for switching to contextual-only mode
 *
 * Displays when user enables "Use contextual criteria only" toggle
 * and incompatible behavioral criteria exist.
 */
function ContextualSwitchModal({
	isOpen,
	onClose,
	onConfirm,
	incompatibleCriteria = [],
}) {
	if (!isOpen) return null;

	return (
		<div className="contextual-switch-modal-overlay">
			<div className="contextual-switch-modal">
				{/* Header */}
				<div className="modal-header">
					<h2>Switch to contextual signals?</h2>
					<button type="button" className="close-btn" onClick={onClose}>
						<img src={xGreenIcon} alt="Close" />
					</button>
				</div>

				{/* Body */}
				<div className="modal-body">
					<p className="warning-message">
						Switching to contextual-only signals will remove all existing behavioral signals, including:
					</p>
					<ul className="criteria-list">
						{incompatibleCriteria.map((criteria, index) => (
							<li key={index}>{criteria}</li>
						))}
					</ul>
				</div>

				{/* Footer */}
				<div className="modal-footer">
					<button
						type="button"
						className="cancel-link"
						onClick={onClose}
					>
						Cancel
					</button>
					<Button
						text="Confirm & Switch"
						type="button"
						style="dark"
						onClick={onConfirm}
					/>
				</div>
			</div>
		</div>
	);
}

ContextualSwitchModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	incompatibleCriteria: PropTypes.arrayOf(PropTypes.string),
};

ContextualSwitchModal.defaultProps = {
	incompatibleCriteria: [],
};

export default ContextualSwitchModal;
